import { useRecoilValueLoadable } from 'recoil';
import { currentUserDetailsAtom } from '../../store/user';
import { RECOIL_LOADABLE_DONE_STATE } from '../../constants/constants';

export default function useCanClaimNewJobs() {
  const userLoadable = useRecoilValueLoadable(currentUserDetailsAtom);

  if (userLoadable.state !== RECOIL_LOADABLE_DONE_STATE) {
    return true;
  }

  return !userLoadable.contents?.paymentTermsUpdateRequired;
}
